<div class="px-3">
  <div class="rem-text-default mb-6">
    <div class="flex align-items-center">
      <div class="rem-bg-light px-3 py-3 mr-2">
        <span class="material-symbols-outlined text-xl">
          {{ displayIcon }}
        </span>
      </div>
      <div>
        <div class="text-2xl font-medium">{{displayText}}</div>
        <div class="text-right mt-2"></div>
      </div>
    </div>
  </div>
</div>

<div class="px-3 navigation-childs">
  <a *ngFor="let child of childMenus" (click)="navigateChild(child)" class="flex align-items-center p-3 mb-2 rounded hoverable">
    <i [ngClass]="'text-xs pi pi-'+ (child?.PrimeNgIconName ?? 'cog')" class="text-2xl font-medium"></i>
    <div class="text-2xl font-medium">
      {{ child?.DisplayText }}
    </div>
  </a>
</div>